import React from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import { isAuthenticatedSelector } from '../../ducks/auth.duck';
import { getPriceDisplayValue, shouldBlurPrice } from '../../util/priceVisibility';

import css from './PriceDisplay.module.css';

const PriceDisplay = props => {
  const { value, className } = props;
  const isAuthenticated = useSelector(isAuthenticatedSelector);

  if (!value) return null;

  const blur = shouldBlurPrice(isAuthenticated);
  const displayValue = getPriceDisplayValue(value, isAuthenticated);
  const classes = classNames(className, { [css.blurred]: blur });

  return <span className={classes}>{displayValue}</span>;
};

export default PriceDisplay;
